import type { UserRole } from '@mairistem/finances-utils';
import React from 'react';
import NotePresentationModal from '../../components/simulation/Outils/NotePresentation/NotePresentationModal';
import type ApercuNotePresentation from '../../interfaces/simulation/apercuNotePresentation';
import type Simulation from '../../interfaces/simulation/simulation';
import BaseOutil from './BaseOutil';

class RedigerNotePresentation extends BaseOutil {
	moduleNotePresentationActif: boolean;

	onApercu: (apercu: ApercuNotePresentation) => void;

	constructor(
		moduleNotePresentationActif: boolean,
		onApercu: (apercu: ApercuNotePresentation) => void,
	) {
		super();
		this.code = 'REDIG_NOTE_PRES';
		this.icon = {
			iconSet: 'Lucide',
			name: 'NotebookTabs',
		};
		this.moduleNotePresentationActif = moduleNotePresentationActif;
		this.onApercu = onApercu;
	}

	title = 'Rédiger la note de présentation';

	// L'outil reste visible sans le module sérialisé, mais transitoirement
	// inactif (étude de la promotion de modules en parallèle)
	isActive(_userRole: UserRole, _simulation: Simulation): boolean {
		return this.moduleNotePresentationActif;
	}

	renderModal(
		simulation: Simulation,
		onClose: () => void,
		onValidate: (data: unknown) => void,
		open: boolean,
	) {
		return (
			<NotePresentationModal
				onApercu={this.onApercu}
				onClose={onClose}
				onValidate={onValidate}
				open={open}
				simulation={simulation}
			/>
		);
	}
}

export default RedigerNotePresentation;
